export default function Stats({ items }) {
  if (!items.length)
    return (
      <h3 className="stats">
        <em>Počnite da dodajete neke stavke na listu za pakovanje 🚀</em>
      </h3>
    );

  const numItems = items.length;
  const numPacked = items.filter((item) => item.packed).length;
  const percentage = Math.round((numPacked / numItems) * 100);

  return (
    <footer className="stats">
      <em>
        {percentage === 100
          ? "Imate sve! Spremni za polazak ✈️"
          : ` 💼 Imate ${numItems} stavke na listi i već ste se spakovali ${numPacked} (${percentage}%)`}
      </em>
    </footer>
  );
}
